import { CanDeactivateFn } from '@angular/router';
import type { OrderBookedPageComponent } from './order-booked-page.component';

/** `canDeactivate` of step 2: the page decides — a live booking is asked about («Бронь останется за вами…»), a finished one is not. A type-only import: the page stays in its lazy chunk. */
export const canLeaveBookedPage: CanDeactivateFn<OrderBookedPageComponent> = component => component.canLeave();
